<template>
  <div id="Anexo">
    <div class>
      <div class="container">
        <!-- <p class="caption">Anexar Documento</p>
        <div class="divider"></div>-->
        <div id="file-upload" class="section">
          <!--Default version-->
          <div class="row section">
            <div class="col s12 m12 l12">
              <div class="col s12 m12 l12">
                <!--<input
                                    ref="arquivoLead"
                type="file" id="input-file-now" class="dropify" data-default-file="" />-->
                <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-success="uploadSuccess"
                  @vdropzone-error="uploadError"
                  @vdropzone-sending="sendingEvent"
                >Arraste e solte seus arquivos aqui</vue-dropzone>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="col s12">
        <div class="col s12">
          <table class="highlight">
            <thead>
              <tr>
                <th style="width: 50%">Nome do arquivo</th>
                <th style="width: 30%">Data</th>
                <th style="width: 20%">Açoes</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(arq, index) in arquivos" :key="`arquivo-${arq.id}`">
                <td style="width: 50%">{{ arq.nome }}</td>
                <td style="width: 30%">{{ arq.data }}</td>
                <td style="width: 20%">
                  <a :href="arq.url" target="_blank">
                    <i class="material-icons text-default">visibility</i>
                  </a>
                  <a @click="removeFile(arq.id, index)" style="cursor: pointer">
                    <i class="material-icons red-text">delete</i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
    get,
    post,
    getUrl,
    remove
} from '@/helpers/api';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Auth from '@/store/auth';
import swal from 'sweetalert2';
import Message from '@/helpers/message';

export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    props: ["pedido"],
    data() {
        return {
            arquivos: [],
            dropzoneOptions: {
                url: getUrl('pedido-anexo/upload'),
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${localStorage.getItem('api_token')}`
                },
                paramName: "arquivo",
                thumbnailWidth: 100,
                thumbnailHeight: 100,
                maxFilesize: 30,
                dictDefaultMessage: '<i class="material-icons">cloud_upload</i> Clique e selecione seus arquivos'
            }
        }
    },
    created() {
        let self = this;
        get("pedido-anexo/get-all-pedido/" + this.pedido.pedido_id).then(
            response => {
                response.data.result.data.forEach(obj => {
                    self.arquivos.push({
                        id: obj.id,
                        nome: obj.filename,
                        data: moment(obj.data).format("DD/MM/YYYY"),
                        url: obj.url
                    });
                });
            }
        );
    },
    mounted() {
        $(this.$refs.arquivoLead).dropify();
    },
    methods: {

        sendingEvent(file, xhr, form_data) {
            form_data.append('pedido_id', this.pedido.pedido_id);
        },
        uploadSuccess(file, {
            result: {
                data
            }
        }) {

            this.arquivos.push({
                nome: data.pedido_anexo_nome,
                data: moment().format("DD/MM/YYYY"),
                url: data.url,
                id: data.pedido_anexo_id
            });

            file.previewElement.parentNode.removeChild(file.previewElement);
            $(".dz-default.dz-message").show();
        },

        uploadError(file, response) {
            Message.messageError(
                "O anexo ultrapassa o limite permitido. Máximo: 30MB"
            );
            this.$refs.myVueDropzone.removeFile(file);
        },

        async removeFile(id, index) {

            const result = await swal({
                title: "Tem certeza que deseja excluir?",
                text: "Você não terá mais acesso a esse registro!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim!",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            })

            if (!result.value) return;

            await remove(`/pedido-anexo/remove/${id}`);

            this.arquivos.splice(index, 1);

            swal("Deletado!", "", "success");

        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/lead/Anexo.vue